<template>  
  <div id="main">  
    <!-- 头部导航区域 -->  
    <header class="site-header" :class="{ 'scrolled': isScrolled }">  
      <el-menu  
        :default-active="1"  
        class="el-menu-demo"  
        mode="horizontal"  
        router 
        background-color="transparent"  
        active-text-color="#14cb85"  
      >  
        <div class="logo">  
          <router-link to="/">  
            <span class="company-name" :class="{ 'scrolled': isScrolled }">艾福罗杰工程咨询</span>  
          </router-link>  
        </div>  

        <el-menu-item index="/" :class="{ 'scrolled': isScrolled }">{{$t("language.HOME")}}</el-menu-item>  
        <el-menu-item index="/CAPABILTIES" :class="{ 'scrolled': isScrolled }">{{$t("language.CAPABILTIES")}}</el-menu-item>  
        <el-menu-item index="/SERVICES" :class="{ 'scrolled': isScrolled }">{{$t("language.SERVICES")}}</el-menu-item>  
        <el-menu-item index="/REFERENCES" :class="{ 'scrolled': isScrolled }">{{$t("language.REFERENCES")}}</el-menu-item>  
        
        <el-sub-menu index="/KEY-PROJECTS" :class="{ 'scrolled': isScrolled }">  
          <template #title>{{$t("language.KEYPROJECTS")}}</template>  
          <el-menu-item index="/KEY-PROJECTS/SHUN-FENG">● 顺丰快件分拣快件中心设计</el-menu-item>  
          <el-menu-item index="/KEY-PROJECTS/SHEN-ZHEN-T3">● 深圳机场T3航站楼行李处理系统适应性评估和改造咨询</el-menu-item>  
          <el-menu-item index="/KEY-PROJECTS/SHEN-ZHEN-SatelliteHall">● 深圳机场卫星厅行李处理系统</el-menu-item>  
          <el-menu-item index="/KEY-PROJECTS/DA-LIAN-BHS">● 大连新机场行李处理系统</el-menu-item>  
          <el-menu-item index="/KEY-PROJECTS/NAN-CHANG-BHS">● 南昌昌北国际机场T3航站楼行李系统设计</el-menu-item>  
          <el-menu-item index="/KEY-PROJECTS/NAN-CHANG-Simulation">● 南昌昌北国际机场T3航站楼旅客模拟仿真</el-menu-item>  
          <el-menu-item index="/KEY-PROJECTS/FU-ZHOU-T2">● 福州机场T2航站楼行李系统模拟仿真</el-menu-item>  
          <el-menu-item index="/KEY-PROJECTS/YANG-ZHOU-T2">● 扬州泰州国际机场T2航站楼行李处理系统</el-menu-item>  
          <!-- <el-menu-item index="/KEY-PROJECTS/TAI-YUAN-Airport">● 深圳机场东枢纽行李处理系统咨询</el-menu-item>   -->
          <el-menu-item index="/KEY-PROJECTS/HE-FEI-T2">● 合肥新桥机场T2航站楼行李处理系统</el-menu-item>  
          <!-- <el-menu-item index="/KEY-PROJECTS/TAI-YUAN-T3">● 太原武宿机场T3航站楼行李处理系统</el-menu-item>  
          <el-menu-item index="/KEY-PROJECTS/SHOU-DU-T2">● 首都机场T2航站楼行李系统整体升级改造项目</el-menu-item>  
          <el-menu-item index="/KEY-PROJECTS/ZHU-HAI-T2">● 珠海机场T2航站楼行李处理系统设计咨询</el-menu-item>  
          <el-menu-item index="/KEY-PROJECTS/YAN-TAI-T2">● 烟台蓬莱国际机场T2航站楼行李处理系统设计咨询</el-menu-item>  
          <el-menu-item index="/KEY-PROJECTS/TAI-YUAN-Airport">● 天津机场T3航站楼旅客流程模拟仿真</el-menu-item>  
          <el-menu-item index="/KEY-PROJECTS/TAI-YUAN-Airport">● 大连新机场航站楼旅客流程模拟仿真</el-menu-item>   -->
        </el-sub-menu>  
        
        <el-menu-item index="/CONTACTUS" :class="{ 'scrolled': isScrolled }">{{$t("language.CONTACT")}}</el-menu-item>  
      </el-menu>  
    </header>  

    <!-- 主要内容区域 -->  
    <main class="site-main">  
      <keep-alive>  
        <router-view :key="$route.path+$route.query"></router-view>  
      </keep-alive>  
    </main>  

    <!-- 底部区域 -->  
    <footer class="site-footer">  
      <div class="footer-content">  
        <el-row>  
          <el-col :span="8">  
            <div class="footer-section">  
              <h3>公司邮箱</h3>  
              <p class="email">  
                <el-icon><phone /></el-icon>  
                information@aiflog.com  
              </p>  
              <p>北京市朝阳区向军南里</p>  
              <p>邮编：100020</p>  
            </div>  
          </el-col>  

          <el-col :span="8">  
            <div class="footer-section">  
              <h3>新闻资讯</h3>  
              <p>公司新闻</p>  
              <p>行业动态</p>  
            </div>  
          </el-col>  

          <el-col :span="8">  
            <div class="footer-section">  
              <h3>关于</h3>  
              <p>关于我们</p>  
            </div>  
          </el-col>  
        </el-row>  

        <div class="copyright">  
          <p>艾福罗杰版权所有 &copy; 2023-2026。京ICP备2024088033号</p>  
        </div>  
      </div>  
    </footer>  
  </div>  
</template>  

<script>  
export default {  
  name: 'App',  
  data() {  
    return {  
      isScrolled: false  
    }  
  },  
  mounted() {  
    window.addEventListener('scroll', this.handleScroll)  
  },  
  beforeDestroy() {  
    window.removeEventListener('scroll', this.handleScroll)  
  },  
  methods: {  
    handleScroll() {  
      this.isScrolled = window.scrollY > 100  
    },  
    handleCommand(command) {  
      switch (command) {  
        case "chinese":  
          localStorage.setItem("language", "zh");  
          this.$i18n.locale = "zh";  
          break;  
        case "english":  
          localStorage.setItem("language", "en");  
          this.$i18n.locale = "en";  
          break;  
      }  
    },  
    updateState(newState) {  
      this.$store.commit('updateNavigationState', newState);  
    }  
  },  
  created() {  
    localStorage.setItem("language", "zh");  
    this.$i18n.locale = "zh";  
  }  
}  
</script>  
<style>  
/* 基础重置 */  
html, body {  
  margin: 0;  
  padding: 0;  
  min-height: 100vh;  
}  

#app {  
  margin: 0;  
  padding: 0;  
  border: 0;  
  list-style: none;  
}  

#main {  
  min-height: 100vh;  
  display: flex;  
  flex-direction: column;  
}  

/* 头部导航样式 */  
.site-header {  
  position: fixed;  
  top: 0;  
  left: 0;  
  right: 0;  
  z-index: 1000;  
  transition: all 0.3s ease;  
  background: transparent;  
}  

/* 滚动后的头部样式 */  
.site-header.scrolled {  
  background: #fff;  
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);  
}  

.el-menu {  
  max-width: 2400px;  
  margin: 0 auto;  
  display: flex;  
  justify-content: center;  
  border: none !important;  
  background: transparent !important;  
}  

.logo {  
  height: 60px;  
  width: 10%;  
  margin-right: 100px;  
  display: flex;  
  align-items: center;  
}  

/* 公司名称样式 */  
.company-name {  
  font-size: 16px;  
  color: #fff;  
  position: absolute;  
  top: 20px;  
  left: 60px;  
  transition: all 0.3s ease;  
}  

.company-name.scrolled {  
  color: #333;  
}  

/* 菜单项样式 */  
.el-menu-item {  
  color: #fff !important;  
  transition: all 0.3s ease;  
}  

/* 菜单项悬停效果 */  
.el-menu-item:hover:not(.is-active) {  
  color: #14cb85 !important;  
}  

/* 滚动后的菜单项样式 */  
.el-menu-item.scrolled {  
  color: #333 !important;  
}  

/* 滚动后菜单项悬停效果 */  
.el-menu-item.scrolled:hover:not(.is-active) {  
  color: #14cb85 !important;  
}  

/* 子菜单标题样式 */  
.el-sub-menu__title {  
  color: #fff !important;  
  transition: all 0.3s ease;  
}  

/* 子菜单标题悬停效果 */  
.el-sub-menu__title:hover {  
  color: #14cb85 !important;  
}  

/* 滚动后的子菜单标题样式 */  
.el-sub-menu.scrolled .el-sub-menu__title {  
  color: #333 !important;  
}  

/* 子菜单样式 */  
.el-menu--horizontal > .el-sub-menu .el-sub-menu__title {  
  height: 60px;  
  line-height: 60px;  
}  

.el-menu--popup {  
  min-width: 200px;  
  background-color: #fff !important;  
}  

/* 子菜单项样式 */  
.el-menu--horizontal .el-menu .el-menu-item {  
  height: 36px;  
  line-height: 36px;  
  padding: 0 20px;  
  color: #333 !important;  
}  

/* 子菜单项悬停效果 */  
.el-menu--horizontal .el-menu .el-menu-item:hover {  
  background-color: #f5f7fa !important;  
  color: #14cb85 !important;  
}  

/* 活动状态的菜单项 */  
.el-menu-item.is-active {  
  color: #14cb85 !important;  
}  

/* 去除默认的hover背景色 */  
.el-menu--horizontal > .el-menu-item:not(.is-disabled):hover,  
.el-menu--horizontal > .el-menu-item:not(.is-disabled):focus,  
.el-menu--horizontal > .el-sub-menu:hover .el-sub-menu__title,  
.el-menu--horizontal > .el-sub-menu:focus .el-sub-menu__title {  
  background-color: transparent !important;  
}  

/* 主要内容区域 */  
.site-main {  
  margin-top: 0px;  
  flex: 1;  
  min-height: 300px;  
  padding: 0px 0px 100px 0px;  
}  

/* 底部样式 */  
.site-footer {  
  background: #1b1b1b;;  
  color: #fff;  
  padding: 40px 0 20px;  
}  

.footer-content {  
  max-width: 2400px;  
  margin: 0 auto;  
  padding: 0 20px;  
}  

.footer-section {  
  padding: 0px 100px;  
}  

.footer-section h3 {  
  color: #c6cbd1;  
  font-size: 20px;  
  margin-bottom: 20px;  
}  

.footer-section p {  
  color: #b0b0b0;  
  margin: 10px 0;  
}  

.footer-section .email {  
  color: #14cb85;  
  font-size: 18px;  
}  

.copyright {  
  text-align: center;  
  margin-top: 40px;  
  padding-top: 20px;  
  border-top: 1px solid #444;  
  color: #888;  
}  

/* 响应式设计 */  
@media (max-width: 768px) {  
  .logo {  
    width: 100%;  
    margin-right: 0;  
    justify-content: center;  
  }  

  .el-menu {  
    flex-direction: column;  
  }  

  .footer-section {  
    text-align: center;  
    margin-bottom: 30px;  
  }  

  .site-header {  
    background: #fff;  
  }  
  
  .el-menu-item,  
  .company-name,  
  .el-sub-menu__title {  
    color: #333 !important;  
  }  
}  

/* 确保子菜单垂直排列 */  
.el-menu--horizontal .el-menu--popup {  
  float: none;  
  display: block;  
  min-width: 200px;  
}  

.el-menu--horizontal .el-menu .el-menu-item,  
.el-menu--horizontal .el-menu .el-sub-menu__title {  
  height: 36px;  
  line-height: 36px;  
  padding: 0 20px;  
  display: block;  
}  

/* 导航菜单过渡效果 */  
.el-menu-item,   
.el-submenu__title {  
  transition: all 0.3s ease !important;  
}  

/* 子菜单弹出层中的菜单项 */  
.el-menu--popup .el-menu-item {  
  color: #333 !important;  
}  

/* 子菜单弹出层中的菜单项悬停效果 */  
.el-menu--popup .el-menu-item:hover {  
  color: #14cb85 !important;  
  background-color: #f5f7fa !important;  
}  

/* 当前激活的子菜单项 */  
.el-menu--horizontal .el-menu .el-menu-item.is-active {  
  color: #14cb85 !important;  
}  
</style>  